import './RoamingCard.scss'
import { Trans, useTranslation } from 'react-i18next'
import wifi from '../../assets/roamingWifiIcon.svg'
import roamingIncomingCall from '../../assets/roamingIncomingCall.svg'
import roamingOutgoingCall from '../../assets/roamingOutgoingCall.svg'

export interface RoamingCardProps {
  className?: string
  incomingCallIcon?: boolean
  outgoingCallIcon?: boolean
  dataIcon?: boolean
  cardTitle?: string
  benefits?: string[]
  benefitsEn?: string[]
  promoText?: string
  extraText?: string
  titleBackgroundColor?: '#016C71' | '#007bff' | '#01376A'
  outgoingCallText?: string
  incomingCallText?: string
  dataText?: string
  ValidityLabel?: string
  validity?: string
  activePeriodUnits?: string
  CoverageLabel?: string
  coverageText?: any
  coverageLinkText?: string
  coverageLink?: string
  textAbovePrice?: string
  price?: string
  unit?: string
  buttonName?: string
  smsText?: string
  smsCode?: string
  isRTL?: boolean
  promoVisibility?: boolean
  extraTextVisibility?: boolean
  children?: any
  onShowCoverageModal?: () => void
  onClickBuyButton?: () => void
}
export const RoamingCard = ({
  className = '',
  cardTitle = '3 Days Roaming Unlimited',
  benefits = ['', ''],
  benefitsEn = ['', ''],
  promoText = 'PROMO',
  extraText = 'EXTRA*',
  titleBackgroundColor = '#01376A',
  incomingCallIcon = true,
  outgoingCallIcon = true,
  dataIcon = true,
  outgoingCallText = 'Outgoing Calls',
  incomingCallText = 'Incoming Calls',
  dataText = 'Unlimited Data',
  ValidityLabel = 'Validity:',
  validity = '3 days',
  activePeriodUnits = 'days',
  CoverageLabel = 'Coverage:',
  coverageText = (
    <>
      {/* <img
        // src={roamingWifiIcon}
        // alt="Roaming Icon"
        // style={{ verticalAlign: 'middle', marginRight: '10px' }}
      /> */}
      XX countries
    </>
  ),
  coverageLinkText = 'See all',
  coverageLink = '',
  textAbovePrice = 'One-time payment',
  price = 'XYZ SAR',
  unit = 'SAR',
  buttonName = 'BUY',
  smsText = 'Trip XYZ',
  smsCode = '1100',
  isRTL = false,
  promoVisibility = false,
  extraTextVisibility = false,
  onShowCoverageModal,
  onClickBuyButton,
  ...props
}: RoamingCardProps) => {
  const dir = isRTL ? 'right' : 'left'
  const promoVisibilityHidden = promoVisibility ? 'visible' : 'hidden'
  const extraVisible = extraTextVisibility ? 'visible' : 'hidden'
  const {t}=useTranslation()
  return (
    <div className={`roaming-card ${className} ${dir}`}>
      <div className="roaming-card-header" style={{ backgroundColor: titleBackgroundColor }}>
        <h2 className="roaming-card-title">{cardTitle}</h2>{' '}
        <div className="promoLabel" style={{ visibility: promoVisibilityHidden }}>
          {' '}
          {promoText}
        </div>
      </div>

      <div className="roaming-card-content ">
        <div className="features">
          <div className="feature">
            {/* <img src={roamingPhoneIcon} alt="Outgoing Calls" /> */}
            <ul className='benefits-list'>
               {benefits.map((benefit, index) => {          
                  const lowerBenefit = benefitsEn[index]?.toLowerCase()
                
                  const isInternet = lowerBenefit.includes('internet') || lowerBenefit.includes('data')
                  const isIncoming = lowerBenefit.includes('incoming')
                  const isOutgoing = lowerBenefit.includes('outgoing')
                
                  return (
                    <li key={index} className="benefit-item">
                      {isInternet && <img src={wifi} alt="Internet" />}
                      {isIncoming && <img src={roamingIncomingCall} alt="Incoming Call" />}
                      {isOutgoing && <img src={roamingOutgoingCall} alt="Outgoing Call" />}
                      {benefit}
                    </li>
                  )
                })}
            </ul>
          </div>

          {/* {incomingCallIcon && (
            <div className="feature">
              <img src={roamingOutgoingCall} alt="Incoming Calls" />
              <span>{incomingCallText}</span>
            </div>
          )}
          {dataIcon && (
            <div className="feature">
              <img src={roamingWifiIcon} alt="Unlimited Data" />
              <span>{dataText}</span>
              <div className="extraLabel" style={{ visibility: extraVisible }}>
                {' '}
                {extraText}
              </div>
            </div>
          )} */}
        </div>
        <div className="roamingDetails">
          <p>
            <span className="label">{t("Validity")}</span>
            <span className="roamingTextColor">{validity}</span> <span>{activePeriodUnits}</span>
          </p>
          <div>
            <span className="label">{t("Coverage")}</span>
            <div className="covergeTextContainer">
              <span className="roamingTextColor">{coverageText}</span>
              <span className="coverageLinkText" onClick={onShowCoverageModal}>
                {t("See_all")}
              </span>
            </div>
          </div>
        </div>

        <hr className="divider" />

        <div className="payment">
          <p className="payment-label">{t("One-time_payment")}</p>
          <p className="price">
           {unit} {price} 
          </p>
          <div className="roamingButton-container">
            <button className="roamingButton" onClick={onClickBuyButton}>
              {buttonName}
            </button>
          </div>
          <p className="sms-info">
            <Trans
              i18nKey="Or_SMS"
              values={{ smsText }}
              components={{
                bold: <strong />
              }}
            />
            {smsCode}
          </p>
        </div>
      </div>
    </div>
  )
}

export default RoamingCard
